import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CustomerHeader } from "./CustomerDashboard";
import { StatusBadge, Loading, EmptyState } from "@/components/common";
import { formatDate } from "@/lib/format";
import { PackageOpen, ArrowRight } from "lucide-react";

export default function CustomerOrders() {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)).catch(() => setOrders(false)); }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <CustomerHeader />
      <div className="max-w-2xl mx-auto px-4 py-6 space-y-4">
        <h1 className="text-2xl font-bold font-display text-slate-900">My Orders</h1>
        {orders === null ? <Loading /> : orders.length === 0 ? (
          <div className="bg-white rounded-xl border"><EmptyState icon={PackageOpen} title="No orders yet" /></div>
        ) : orders.map((o) => (
          <Link key={o.order_id} to={`/portal/orders/${o.order_id}`} data-testid={`customer-order-${o.order_id}`}
            className="block bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-semibold font-display text-slate-900">{o.plan_name || o.business_name}</div>
                <div className="text-xs text-slate-500 font-mono mt-0.5">{o.order_id}</div>
                <div className="text-xs text-slate-500 mt-1">{formatDate(o.start_date)} → {formatDate(o.end_date)}</div>
              </div>
              <StatusBadge status={o.status} />
            </div>
            <div className="mt-3 flex items-center justify-between text-sm">
              <span className="text-blue-700 font-medium inline-flex items-center gap-1">View Details <ArrowRight className="h-3.5 w-3.5" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
